export default __webpack_public_path__ + "static/yara-coffeeclub-logo-da81f898ca802b9f201125633ed08d57.svg";